// extracted by mini-css-extract-plugin
export default {"root":"YaLObkkrR02Jh1hjxNdt","overflow":"WJTwnBNwN7veuAJhUO1K","success":"gHaavVXmEPsqTVJOfY3R","placeHolderShimmer":"bVFXg6OuvzKA0OT6UbXr"};